(function () {
  function initReveal() {
    var targets = [];
    document.querySelectorAll('.shopify-section').forEach(function (el) {
      if (/header|announcement-bar/i.test(el.id)) return;
      if (!el.classList.contains('tr-reveal')) el.classList.add('tr-reveal');
      targets.push(el);
    });
    document.querySelectorAll('ul.grid').forEach(function (el) {
      if (!el.classList.contains('tr-stagger')) el.classList.add('tr-stagger');
      targets.push(el);
    });
    document.querySelectorAll('.tr-reveal, .tr-stagger').forEach(function (el) {
      if (targets.indexOf(el) === -1) targets.push(el);
    });

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('tr-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tr-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  // Groups the flat <h3>/<p> sequence rendered from a rich-text metafield
  // (via the metafield_tag filter) into individual spec cards.
  function initSpecGrids() {
    document.querySelectorAll('.tr-spec-grid .metafield-rich_text_field').forEach(function (container) {
      if (container.dataset.trGrouped) return;
      var children = Array.prototype.slice.call(container.children);
      if (!children.length) return;
      var cards = [];
      var current = null;
      children.forEach(function (el) {
        if (/^H[1-6]$/.test(el.tagName)) {
          current = document.createElement('div');
          current.className = 'tr-spec-card';
          current.appendChild(el);
          cards.push(current);
        } else if (current) {
          current.appendChild(el);
        } else {
          current = document.createElement('div');
          current.className = 'tr-spec-card';
          current.appendChild(el);
          cards.push(current);
        }
      });
      if (cards.length) {
        cards.forEach(function (c) { container.appendChild(c); });
        container.dataset.trGrouped = 'true';
        container.classList.add('tr-spec-grid-inner');
      }
    });
  }

  function init() {
    initSpecGrids();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
